import SectionLabel from "@/components/base/SectionLabel";
import { aiDigitalData } from "@/mocks/aiDigitalData";

export default function DeliverablesSection() {
  return (
    <section className="py-16 md:py-22 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel label={aiDigitalData.deliverables.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {aiDigitalData.deliverables.title}
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          {/* Document mockup card */}
          <div className="reveal rounded-lg bg-background-50 border border-background-200/70 overflow-hidden">
            {/* Header bar */}
            <div className="bg-primary-500/[0.06] border-b border-background-200/70 px-5 md:px-7 py-4 flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-primary-500/10 flex items-center justify-center">
                <i className="ri-folder-3-line text-primary-500 text-lg" />
              </div>
              <div>
                <p className="text-sm font-bold text-foreground-900 font-heading">
                  導入後に残る資料一式
                </p>
                <p className="text-xs text-foreground-500">
                  使い続けるために必要な記録とルール
                </p>
              </div>
            </div>

            {/* Items */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-0">
              {aiDigitalData.deliverables.items.map((item, idx) => (
                <div
                  key={idx}
                  className={`flex items-center gap-3 px-5 md:px-7 py-3.5 ${
                    idx < aiDigitalData.deliverables.items.length - 2 ||
                    (aiDigitalData.deliverables.items.length % 2 === 0 &&
                      idx < aiDigitalData.deliverables.items.length - 1)
                      ? "border-b border-background-200/50"
                      : ""
                  } ${idx % 2 === 0 && idx < aiDigitalData.deliverables.items.length - 1 ? "sm:border-r border-background-200/50" : ""}`}
                  style={{ transitionDelay: `${idx * 60}ms` }}
                >
                  <div className="w-8 h-8 rounded-lg bg-primary-500/10 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-primary-500`} />
                  </div>
                  <span className="text-sm text-foreground-800">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}